import { useEffect, useState } from 'react';
import styled from 'styled-components';

import Button from '@r1-frontend/ui-react/components/buttons/button';
import { ButtonGroup } from '@r1-frontend/ui-react/components/buttons/buttonGroup/ButtonGroup';
import { TickCircle } from '@r1-frontend/ui-react/components/svg/main';
import { H3 } from '@r1-frontend/ui-react/components/typography/heading';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import { IndentContainer, ListContainer } from '@r1-frontend/ui-react/experimental/containers';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';

import { TBaseSubscription } from '~/src/features/tariffBuilder/reducer/initialState';

import * as ST from './styled';

interface IProps {
    titlePrefix: string | null,
    onClose: () => void,
    subscription?: (TBaseSubscription & { isSelected: boolean }),
}

const OnlineCinemaAdditionalInfo = ({
    titlePrefix,
    onClose,
    subscription,
    ...props
}: IProps): JSX.Element | null => {
    const [benefits, setBenefits] = useState<string[]>([]);
    useEffect(() => {
        if (!subscription) {
            return;
        }
        const matchAll = Array.from(subscription.descriptionFull.matchAll(/<li>(.*?)<\/li>/g));
        setBenefits(matchAll.map(item => item[1]));
    }, [subscription]);

    if (!subscription) {
        return null;
    }

    return (
        <div {...props}>
            <ST.ImageBlock src={subscription.imagePath.desktop} alt={`Изображение ${subscription.title}`} visibleByDefault/>
            <IndentContainer $desktop={[32]} $mobile={[24]}>
                <H3>{titlePrefix && `${titlePrefix} `}{subscription.title}</H3>
                <ListContainer $size={16}>
                    {benefits.map((item: string, index: number) =>
                        <ST.BenefitsText key={index}>
                            <TickCircle size={20} />
                            <Paragraph4 $color={COLORS.TextInfo} dangerouslySetInnerHTML={{ __html: item }}/>
                        </ST.BenefitsText>)
                    }
                </ListContainer>
                <ButtonGroup>
                    <Button
                        bType={'action'}
                        size={'medium'}
                        onClick={onClose}
                    >
                        Закрыть
                    </Button>
                </ButtonGroup>
            </IndentContainer>
        </div>
    );
};

export default styled(OnlineCinemaAdditionalInfo)`
    ${ListContainer} {
        margin-bottom: 16px;
    }
`;
